import { StringVariant } from 'src/features/string-group-detail/types';

/**
 * The draft's variants that the server does not have yet.
 *
 * `draftEntry.variants` is NOT a pending list. For an `edited` entry it is the
 * server list (seeded from the server snapshot) plus any upserted variants, so
 * it is a superset — presence in the draft says nothing on its own. A variant is
 * pending-new only when its CX ID is absent from the server list. A draft
 * variant whose CX ID IS on the server is an *edit* of a variant that already
 * exists, so it is deliberately not returned here: it still has a detail page
 * and must stay linked.
 *
 * This is the one place "which CX IDs are pending" is decided —
 * `computeAvailableCxIds` is fed from it — so the Create Variant dropdown and
 * the Manage Variants table cannot disagree.
 */
export function computePendingVariants(
  serverVariants: readonly { cxId: string }[] | null | undefined,
  draftVariants: readonly StringVariant[] | null | undefined,
): StringVariant[] {
  const onServer = new Set((serverVariants ?? []).map((v) => v.cxId));
  return (draftVariants ?? []).filter((v) => !onServer.has(v.cxId));
}
